import { useMutation } from '@tanstack/react-query';

import { PluginCreditSenseRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { runCreditSenseRequest } from '../../requests/runCreditSenseRequest';

export const useRunCreditSenseRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginCreditSenseRequest) =>
      runCreditSenseRequest(constructPost, data),
    onSuccess: () => handleSuccess('CreditSense bank statements requested'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Credit Sense request failed.')),
  });
  return { runCreditSenseRequest: mutateAsync, ...rest };
};
